import { z } from 'zod/v4';
export const MessageSuggestionSchema = z.object({
    body: z.string(),
});
// Built-in sensitivity flags for auto-reply judge evaluation
export var SensitivityFlag;
(function (SensitivityFlag) {
    SensitivityFlag["CourtLegal"] = "COURT_LEGAL";
    SensitivityFlag["Police"] = "POLICE";
    SensitivityFlag["FinancialHardship"] = "FINANCIAL_HARDSHIP";
    SensitivityFlag["Dispute"] = "DISPUTE";
    SensitivityFlag["ThreatHostile"] = "THREAT_HOSTILE";
    SensitivityFlag["MedicalHealth"] = "MEDICAL_HEALTH";
})(SensitivityFlag || (SensitivityFlag = {}));
// Descriptions for built-in flags (used in judge prompt) - bilingual with Danish keywords
export const SensitivityFlagDescriptions = {
    [SensitivityFlag.CourtLegal]: 'Court, lawyers, legal proceedings (e.g., "retten", "foged", "advokat", "stævning")',
    [SensitivityFlag.Police]: 'Police involvement (e.g., "politi", "anmeldelse", "politianmeldelse")',
    [SensitivityFlag.FinancialHardship]: 'Claims of inability to pay (e.g., "kan ikke betale", "økonomiske problemer", "gældssanering")',
    [SensitivityFlag.Dispute]: 'Disputes about debt validity (e.g., "bestrid", "ikke min gæld", "uenig", "fejl")',
    [SensitivityFlag.ThreatHostile]: 'Threats or hostile language (e.g., "trussel", "sagsøge", aggressive tone)',
    [SensitivityFlag.MedicalHealth]: 'Medical/health issues affecting ability to pay (e.g., "syg", "hospital", "behandling")',
};
export var SuggestionAction;
(function (SuggestionAction) {
    SuggestionAction["Update"] = "UPDATE";
    SuggestionAction["Interaction"] = "INTERACTION";
    SuggestionAction["NoSuggestion"] = "NO_SUGGESTION";
})(SuggestionAction || (SuggestionAction = {}));
export const SuggestionActionSchema = z.enum(SuggestionAction);
export const SuggestionSchema = z.union([
    z.object({
        action: z.literal(SuggestionAction.Update),
        updateTypeId: z.uuid(),
    }),
    z.object({
        action: z.literal(SuggestionAction.Interaction),
        templateId: z.uuid(),
    }),
    z.object({
        action: z.literal(SuggestionAction.NoSuggestion),
    }),
]);
// Multipliers and the credit-USD rate are frozen onto each usage row at write time — changing these constants only affects future rows
export var AICreditFeature;
(function (AICreditFeature) {
    AICreditFeature["MessageSuggestion"] = "MESSAGE_SUGGESTION";
    AICreditFeature["Categorization"] = "CATEGORIZATION";
    AICreditFeature["AutoReply"] = "AUTO_REPLY";
    AICreditFeature["CategoryDiscovery"] = "CATEGORY_DISCOVERY";
    AICreditFeature["Agent"] = "AGENT";
})(AICreditFeature || (AICreditFeature = {}));
export const CREDIT_FEATURE_MULTIPLIERS = {
    [AICreditFeature.MessageSuggestion]: 3,
    [AICreditFeature.Categorization]: 5,
    [AICreditFeature.AutoReply]: 3,
    [AICreditFeature.CategoryDiscovery]: 5,
    [AICreditFeature.Agent]: 5,
};
export const CREDITS_PER_USD = 1;
export const costToCredits = (costInNanocents, multiplier) => costInNanocents * BigInt(multiplier) * BigInt(CREDITS_PER_USD);
//# sourceMappingURL=index.js.map